module.exports = __webpack_public_path__ + "static/media/radio.5e0a3b16.svg";